import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface DialogData {
  id: number;
}

@Component({
  selector: 'user-modal-return-trailer',
  templateUrl: './modal-return-trailer.component.html',
  styleUrls: ['./modal-return-trailer.component.scss']
})
export class ModalReturnTrailerComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalReturnTrailerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
